import { fetchBalance } from "../utils/api";
import { useState, useEffect } from "react";
import { TBalance } from "../utils/types";
type MerchantBalance = Record<string, TBalance>;

export const useBalance = () => {
  const [balance, setBalance] = useState<MerchantBalance>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [total, setTotal] = useState<number | null>(null);

  const handleGet = (res: { data: MerchantBalance }) => {
    setBalance(res.data);
  };

  const getBalance = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetchBalance();
      handleGet(res);
    } catch (err) {
      console.error("Ошибка при получении баланса:", err);
      setError("Ошибка при получении баланса");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBalance();
  }, []);

  return {
    balance,
    loading,
    error,
    setError,
    total,
    getBalance,
  };
};
